import { useWorkPeriodStore } from "@/store/work-periods.store.ts"
import { storeToRefs } from "pinia"
import { WorkPeriodController } from "@/controllers/model-controllers/work-period-controller.ts"
import type { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import type { WorkPeriod } from "@/models/work-period.model.ts"
import type { Moment } from "moment/moment"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"

export class AppWorkPeriodController extends WorkPeriodController {
  constructor() {
    const workPeriodStore = useWorkPeriodStore()
    const { appWorkPeriods } = storeToRefs(workPeriodStore)
    const storeFunctionsConfig = {
      collection: appWorkPeriods,
      managed: false
    }
    super(storeFunctionsConfig)
  }

  public getListForKnownBusinessEntityContactAndDate(
    kbec: KnownBusinessEntityContact,
    date: Moment
  ) {
    const workPeriodStore = useWorkPeriodStore()
    const { appWorkPeriodsBeingFetchedCount } = storeToRefs(workPeriodStore)
    return super.getListForKnownBusinessEntityContactAndDate(
      kbec,
      date,
      appWorkPeriodsBeingFetchedCount,
      true
    )
  }

  public getIncompleteWorkPeriodForKnownBusinessEntity(pbu: KnownBusinessEntityContact) {
    const query = new ODataQueryBuilder().eq("owner_id", pbu.id).eq("time_end", null).deep() // Important, else we will have validation issues on work period update
    return this.getList({ query })
  }

  /**
   * Registers a work period that was already persisted server-side (e.g. created atomically from
   * a template by a different controller) into the store.
   */
  public addExistingWorkPeriod(workPeriod: WorkPeriod): Promise<WorkPeriod> {
    return this.storeFunctions.createModel(workPeriod)
  }
}
